import { render } from "./DynamicCollapse.vue?vue&type=template&id=46675b3c&scoped=true"
import script from "./DynamicCollapse.vue?vue&type=script&lang=ts"
export * from "./DynamicCollapse.vue?vue&type=script&lang=ts"

import "./DynamicCollapse.vue?vue&type=style&index=0&id=46675b3c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-46675b3c"

export default script